import { Button, Modal } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { useCallback } from "react";
import { getFullName } from "../../../../utils/shared";
import { updateConversation } from "../../../../store/chats/thunks";
import { useDispatch, useSelector } from "react-redux";
import { selectSelectedTenantId } from "../../../../store/user/selectors";

const RemoveMember = (props) => {
  const { user, conversation_id } = props;

  const dispatch = useDispatch();
  const tenant_id = useSelector(selectSelectedTenantId);

  const handleRemoveUser = useCallback(() => {
    Modal.confirm({
      title: "Remove User",
      content: `Are you sure you want to remove ${getFullName(
        user
      )} from this Group?`,
      okText: "Yes, Remove",
      okType: "danger",
      onOk: () => {
        return new Promise(async (resolve, reject) => {
          try {
            const result = await dispatch(
              updateConversation({
                payload: {
                  conversation_id,
                  remove: [user?.id],
                  tenant_id,
                },
              })
            );

            resolve(result);
          } catch (error) {
            console.error(
              "🚀 ~ BranchesUserCards.jsx ~ handleRemoveUser ~ error:",
              error
            );
            reject(error);
          }
        });
      },
      onCancel: () => {
        console.log("User removal cancelled");
      },
    });
  }, [user, tenant_id, conversation_id]);

  return (
    <Button
      icon={<DeleteOutlined />}
      onClick={handleRemoveUser}
      type="text"
      danger
      className="delete-member-btn"
    />
  );
};

export default RemoveMember;
